import { DownloadItem } from '../../../DownloadItem/DownloadItem.client';

export type DataSheetsProps = {
  dataSheetUrls: string[];
  /** Optional product name, named in each datasheet link for screen readers. */
  productName?: string;
};

export const DataSheets = ({ dataSheetUrls, productName }: DataSheetsProps) => (
  <div className="flex flex-col items-center gap-1">
    {dataSheetUrls.map((datasheet, index) => (
      <DownloadItem
        key={datasheet}
        link={datasheet}
        type="PRODUCT_DATASHEET"
        linkTextExtension={dataSheetUrls.length > 1 ? index + 1 : undefined}
        renderIcon={false}
        productName={productName}
      />
    ))}
  </div>
);
